<template>
    <div class='text-container'>
      <div class='header'>{{head}}</div>
      <pre class='text'>{{info}}</pre>
      <div class='button' @click='close'>Got it</div>
      <div class='diamond'/>
    </div>
</template>

<script>
export default {
  props: ['head', 'info'],
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
.text-container {
  position: fixed;
  width: fit-content;
  height: fit-context;
  border-radius: 8px;
  z-index: 3;
  background: #FFFFFF;
  box-shadow: 0px 3px 6px #00000029;
  .header{
    margin: 25px 25px 0 25px;
    font-size: 16px;
    line-height: 20px;
    color: #000000;
    font-family: 'VWHeadWeb';
    font-weight: bold;
  }
  .text{
    margin: 11.5px 25px 0 25px;
    font-size: 14px;
    line-height: 17px;
    color: #000000;
    font-family: 'VWTextWeb';
  }
  .button{
    margin: 19.8px auto 20px auto;
    width: 132px;
    height: 34px;
    border-radius: 25px;
    text-align: center;
    line-height: 34px;
    font-family: 'VWTextWeb';
    font-size: 13px;
    color: #001E50;
    background: #00B0F0;
    z-index: 4;
  }
  .diamond {
    position: absolute;
    top: calc(100% - 10px);
    left: calc(50% - 10px);
    width: 20px;
    height: 20px;
    background: #ffffff;
    transform: rotateY(0deg) rotate(45deg);
    z-index: -1;
    @media screen and (max-width: 1050px) {
      opacity: 0;
    }
  }
}
</style>
